import { render, staticRenderFns } from "./padding-rule.vue?vue&type=template&id=264f58f7&scoped=true"
import script from "./padding-rule.vue?vue&type=script&lang=js"
export * from "./padding-rule.vue?vue&type=script&lang=js"
import style0 from "./padding-rule.vue?vue&type=style&index=0&id=264f58f7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264f58f7",
  null
  
)

export default component.exports